import PublishPostModal from "@components/_modals/Group/PublishPost";

import useGroup from "./hooks/useGroup";
import GroupView from "./view";

export default function Group({ community, triggerEdit }) {
    const state = useGroup({ community, triggerEdit });

    return (
        <>
            <GroupView {...state} />
            <PublishPostModal modalRef={state.createPostModalRef} />
        </>
    );
}
